import { render, staticRenderFns } from "./selecionarInstituto.vue?vue&type=template&id=1773c9be"
import script from "./selecionarInstituto.vue?vue&type=script&lang=js"
export * from "./selecionarInstituto.vue?vue&type=script&lang=js"
import style0 from "./selecionarInstituto.vue?vue&type=style&index=0&id=1773c9be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports